<template>
  <div
    class="relative p-px pr-0 last:pr-px bg-[linear-gradient(103.17deg,_rgba(58,42,123,0.5)_1.54%,_rgba(58,27,132,0.5)_98.46%)] min-w-[302px] before:content-[''] before:size-2 before:bg-[#4902A6] before:absolute before:bottom-0 before:left-0 before:-translate-x-1/2 after:content-[''] after:size-2 after:bg-[#4902A6] after:absolute after:top-0 after:left-0 after:-translate-x-1/2 after:-translate-y-1/2"
  >
    <Card unstyled class="px-9 py-7 bg-white dark:bg-[#1B022B] w-full h-full">
      <template #header>
        <p class="text-[rgb(173,140,245)]">{{ id }}</p>
        <div
          v-if="img"
          class="ml-4 -mt-4 rounded-full bg-[linear-gradient(141.14deg,_#51277B_13.17%,_#8F5BC4_84.19%)] p-[3px] max-w-max overflow-hidden size-[120px]"
        >
          <NuxtImg
            :src="img"
            width="116"
            height="116"
            class="rounded-full"
            alt="team image"
            loading="lazy"
             format="webp"
          />
        </div>
        <h3
          :class="twMerge('text-xl font-semibold mt-3.5', titleClass)"
          v-html="designation"
        ></h3>
      </template>
      <template #content>
        <p class="text-sm mt-4 dark:text-[#AE5DE8]">
          {{ description }}
        </p>
      </template>
    </Card>
  </div>
</template>

<script setup lang="ts">
import { twMerge } from "tailwind-merge";

type Props = {
  id?: string;
  designation?: string;
  description?: string;
  img?: string;
  titleClass?: string;
};

const props = withDefaults(defineProps<Props>(), {
  id: "1",
  designation: "Web Developers",
  description:
    "Get temporary or permanent assistance from our user experience and user interface experts.",
});
</script>
